export const vendorFields: Record<string, { name: string; label: string }[]> = {
  'Ambulance Agency': [
    { name: 'agencyName', label: 'Agency Name' },
    { name: 'gstNumber', label: 'GST Number' },
    { name: 'panNumber', label: 'PAN Number' },
    { name: 'ownerName', label: 'Owner Name' },
    { name: 'registrationNumber', label: 'Registration Number' },
    { name: 'address', label: 'Address' },
    { name: 'landmark', label: 'Landmark' },
    { name: 'contactNumber', label: 'Contact Number' },
    { name: 'email', label: 'Email' },
    { name: 'website', label: 'Website' },
    { name: 'numOfAmbulances', label: 'Number of Ambulances' },
    { name: 'driverKYC', label: 'Driver KYC' },
    { name: 'driverTrained', label: 'Driver Trained' },
    { name: 'ambulanceTypes', label: 'Ambulance Types' },
    { name: 'gpsTrackingAvailable', label: 'GPS Tracking Available' },
    { name: 'ambulanceEquipment', label: 'Ambulance Equipment' },
    { name: 'trainingCertifications', label: 'Training Certifications' },
    { name: 'languageProficiency', label: 'Language Proficiency' },
    { name: 'operationalAreas', label: 'Operational Areas' },
    { name: 'is24x7Available', label: '24x7 Available' },
    { name: 'distanceLimit', label: 'Distance Limit' },
    { name: 'isOnlinePaymentAvailable', label: 'Online Payment Available' },
    { name: 'officePhotos', label: 'Office Photos' },
    { name: 'preciseLocation', label: 'Precise Location' },
    { name: 'driverLicense', label: 'Driver License' },
    { name: 'state', label: 'State' },
    { name: 'city', label: 'City' },
    { name: 'pinCode', label: 'Pin Code' },
  ],
  'Blood Bank Agency': [
    { name: 'agencyName', label: 'Agency Name' },
    { name: 'gstNumber', label: 'GST Number' },
    { name: 'panNumber', label: 'PAN Number' },
    { name: 'ownerName', label: 'Owner Name' },
    { name: 'completeAddress', label: 'Complete Address' },
    { name: 'nearbyLandmark', label: 'Nearby Landmark' },
    { name: 'phoneNumber', label: 'Phone Number' },
    { name: 'state', label: 'State' },
    { name: 'city', label: 'City' },
    { name: 'pincode', label: 'Pin Code' },
    { name: 'email', label: 'Email' },
    { name: 'website', label: 'Website' },
    { name: 'languageProficiency', label: 'Language Proficiency' },
    { name: 'deliveryOperationalAreas', label: 'Delivery Operational Areas' },
    { name: 'distanceLimitations', label: 'Distance Limitations' },
    { name: 'is24x7Operational', label: '24x7 Operational' },
    { name: 'isAllDaysWorking', label: 'All Days Working' },
    { name: 'bloodServicesProvided', label: 'Blood Services Provided' },
    { name: 'plateletServicesProvided', label: 'Platelet Services Provided' },
    { name: 'otherServicesProvided', label: 'Other Services Provided' },
    { name: 'acceptsOnlinePayment', label: 'Accepts Online Payment' },
    { name: 'agencyPhotos', label: 'Agency Photos' },
    { name: 'licenseFiles', label: 'License Files' },
    { name: 'registrationCertificateFiles', label: 'Registration Certificate Files' },
    { name: 'googleMapsLocation', label: 'Google Maps Location' },
  ],
  'Doctor Clinic': [
    { name: 'doctorName', label: 'Doctor Name' },
    { name: 'gender', label: 'Gender' },
    { name: 'email', label: 'Email' },
    { name: 'password', label: 'Password' },
    { name: 'confirmPassword', label: 'Confirm Password' },
    { name: 'phoneNumber', label: 'Phone Number' },
    { name: 'profilePicture', label: 'Profile Picture' },
    { name: 'medicalLicenseFile', label: 'Medical License File' },
    { name: 'licenseNumber', label: 'License Number' },
    { name: 'educationalQualifications', label: 'Educational Qualifications' },
    { name: 'specializations', label: 'Specializations' },
    { name: 'experienceYears', label: 'Experience (Years)' },
    { name: 'languageProficiency', label: 'Language Proficiency' },
    { name: 'hasTelemedicineExperience', label: 'Has Telemedicine Experience' },
    { name: 'consultationFeesRange', label: 'Consultation Fees Range' },
    { name: 'consultationTimeSlots', label: 'Consultation Time Slots' },
    { name: 'consultationDays', label: 'Consultation Days' },
    { name: 'consultationTypes', label: 'Consultation Types' },
    { name: 'insurancePartners', label: 'Insurance Partners' },
    { name: 'address', label: 'Address' },
    { name: 'state', label: 'State' },
    { name: 'city', label: 'City' },
    { name: 'pincode', label: 'Pin Code' },
    { name: 'nearbyLandmark', label: 'Nearby Landmark' },
    { name: 'floor', label: 'Floor' },
    { name: 'hasLiftAccess', label: 'Has Lift Access' },
    { name: 'hasWheelchairAccess', label: 'Has Wheelchair Access' },
    { name: 'hasParking', label: 'Has Parking' },
    { name: 'otherFacilities', label: 'Other Facilities' },
    { name: 'clinicPhotos', label: 'Clinic Photos' },
    { name: 'location', label: 'Location' },
  ],
  'Hospital': [
    { name: 'name', label: 'Hospital Name' },
    { name: 'gstNumber', label: 'GST Number' },
    { name: 'panNumber', label: 'PAN Number' },
    { name: 'address', label: 'Address' },
    { name: 'landmark', label: 'Landmark' },
    { name: 'ownerName', label: 'Owner Name' },
    { name: 'certifications', label: 'Certifications' },
    { name: 'licenses', label: 'Licenses' },
    { name: 'specialityTypes', label: 'Speciality Types' },
    { name: 'servicesOffered', label: 'Services Offered' },
    { name: 'bedsAvailable', label: 'Beds Available' },
    { name: 'doctors', label: 'Doctors' },
    { name: 'workingTime', label: 'Working Time' },
    { name: 'workingDays', label: 'Working Days' },
    { name: 'contactNumber', label: 'Contact Number' },
    { name: 'email', label: 'Email' },
    { name: 'website', label: 'Website' },
    { name: 'hasLiftAccess', label: 'Has Lift Access' },
    { name: 'hasParking', label: 'Has Parking' },
    { name: 'providesAmbulanceService', label: 'Provides Ambulance Service' },
    { name: 'about', label: 'About' },
    { name: 'hasWheelchairAccess', label: 'Has Wheelchair Access' },
    { name: 'providesOnlineConsultancy', label: 'Provides Online Consultancy' },
    { name: 'feesRange', label: 'Fees Range' },
    { name: 'otherFacilities', label: 'Other Facilities' },
    { name: 'insuranceCompanies', label: 'Insurance Companies' },
    { name: 'photos', label: 'Photos' },
    { name: 'state', label: 'State' },
    { name: 'city', label: 'City' },
    { name: 'pincode', label: 'Pin Code' },
    { name: 'location', label: 'Location' },
    { name: 'password', label: 'Password' },
  ],
  'Diagnostic Center': [
    { name: 'name', label: 'Center Name' },
    { name: 'gstNumber', label: 'GST Number' },
    { name: 'panNumber', label: 'PAN Number' },
    { name: 'ownerName', label: 'Owner Name' },
    { name: 'regulatoryComplianceUrl', label: 'Regulatory Compliance URL' },
    { name: 'qualityAssuranceUrl', label: 'Quality Assurance URL' },
    { name: 'sampleCollectionMethod', label: 'Sample Collection Method' },
    { name: 'testTypes', label: 'Test Types' },
    { name: 'businessTimings', label: 'Business Timings' },
    { name: 'businessDays', label: 'Business Days' },
    { name: 'homeCollectionGeoLimit', label: 'Home Collection Geo Limit' },
    { name: 'emergencyHandlingFastTrack', label: 'Emergency Handling Fast Track' },
    { name: 'address', label: 'Address' },
    { name: 'state', label: 'State' },
    { name: 'city', label: 'City' },
    { name: 'pincode', label: 'Pin Code' },
    { name: 'nearbyLandmark', label: 'Nearby Landmark' },
    { name: 'floor', label: 'Floor' },
    { name: 'parkingAvailable', label: 'Parking Available' },
    { name: 'wheelchairAccess', label: 'Wheelchair Access' },
    { name: 'liftAccess', label: 'Lift Access' },
    { name: 'ambulanceServiceAvailable', label: 'Ambulance Service Available' },
    { name: 'mainContactNumber', label: 'Main Contact Number' },
    { name: 'emergencyContactNumber', label: 'Emergency Contact Number' },
    { name: 'email', label: 'Email' },
    { name: 'website', label: 'Website' },
    { name: 'languagesSpoken', label: 'Languages Spoken' },
    { name: 'centerPhotosUrl', label: 'Center Photos URL' },
    { name: 'googleMapsLocationUrl', label: 'Google Maps Location URL' },
    { name: 'password', label: 'Password' },
    { name: 'filesAndImages', label: 'Files and Images' },
    { name: 'location', label: 'Location' },
  ],
  'Medical Store': [
    { name: 'name', label: 'Store Name' },
    { name: 'address', label: 'Address' },
    { name: 'landmark', label: 'Landmark' },
    { name: 'state', label: 'State' },
    { name: 'city', label: 'City' },
    { name: 'pincode', label: 'Pin Code' },
    { name: 'contactNumber', label: 'Contact Number' },
    { name: 'emailId', label: 'Email' },
    { name: 'ownerName', label: 'Owner Name' },
    { name: 'licenseNumber', label: 'License Number' },
    { name: 'gstNumber', label: 'GST Number' },
    { name: 'panNumber', label: 'PAN Number' },
    { name: 'storeTiming', label: 'Store Timing' },
    { name: 'storeDays', label: 'Store Days' },
    { name: 'floor', label: 'Floor' },
    { name: 'medicineType', label: 'Medicine Type' },
    { name: 'isRareMedicationsAvailable', label: 'Rare Medications Available' },
    { name: 'isOnlinePayment', label: 'Online Payment' },
    { name: 'isLiftAccess', label: 'Lift Access' },
    { name: 'isWheelchairAccess', label: 'Wheelchair Access' },
    { name: 'isParkingAvailable', label: 'Parking Available' },
    { name: 'location', label: 'Location' },
    { name: 'availableMedicines', label: 'Available Medicines' },
    { name: 'registrationCertificates', label: 'Registration Certificates' },
    { name: 'complianceCertificates', label: 'Compliance Certificates' },
    { name: 'photos', label: 'Photos' },
  ],
  'Product Partner': [
    { name: 'password', label: 'Password' },
    { name: 'companyLegalName', label: 'Company Legal Name' },
    { name: 'brandName', label: 'Brand Name' },
    { name: 'gstNumber', label: 'GST Number' },
    { name: 'panCardNumber', label: 'PAN Card Number' },
    { name: 'licenseDetails', label: 'License Details' },
    { name: 'address', label: 'Address' },
    { name: 'pincode', label: 'Pin Code' },
    { name: 'city', label: 'City' },
    { name: 'state', label: 'State' },
    { name: 'email', label: 'Email' },
    { name: 'bankAccountNumber', label: 'Bank Account Number' },
    { name: 'profilePicture', label: 'Profile Picture' },
    { name: 'location', label: 'Location' },
    { name: 'phoneNumber', label: 'Phone Number' },
  ],
}; 